import { useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Modal from "../Modal";
import {
  // Negócios e Comércio
  RiShoppingBag3Line,
  RiShoppingCart2Line,
  RiStore2Line,
  RiShoppingBasketLine,
  RiBriefcase4Line,
  RiHandCoinLine,
  RiMoneyDollarCircleLine,
  RiCoupon3Line,
  RiPriceTag3Line,
  RiBarcodeLine,
  RiWallet3Line,
  RiRefund2Line,
  RiExchangeLine,
  RiAuctionLine,
  RiSecurePaymentLine,

  // Destaque e Reconhecimento
  RiStarLine,
  RiTrophyLine,
  RiMedalLine,
  RiAwardLine,
  RiCupLine,
  RiVipCrownLine,
  RiVipDiamondLine,
  RiShieldStarLine,

  // Emoções e Social
  RiHeartLine,
  RiEmotionHappyLine,
  RiEmotionLaughLine,
  RiThumbUpLine,
  RiThumbDownLine,
  RiHandHeartLine,
  RiUserHeartLine,
  RiTeamLine,
  RiUserStarLine,
  RiUserSmileLine,

  // Tecnologia e Dispositivos
  RiComputerLine,
  RiSmartphoneLine,
  RiTabletLine,
  RiMacbookLine,
  RiServerLine,
  RiHardDriveLine,
  RiDatabase2Line,
  RiCloudLine,
  RiWifiLine,
  RiUsbLine,
  RiCpuLine,

  // Ferramentas e Configurações
  RiToolsLine,
  RiSettings3Line,
  RiSettings4Line,
  RiHammerLine,
  RiScissorsLine,
  RiPaintBrushLine,
  RiPaletteLine,
  RiMagicLine,
  RiDragDropLine,
  RiEdit2Line,
  RiPencilLine,

  // Mídia e Entretenimento
  RiCameraLine,
  RiVideoLine,
  RiFilmLine,
  RiMusic2Line,
  RiHeadphoneLine,
  RiMicLine,
  RiVolumeUpLine,
  RiPlayCircleLine,
  RiPauseCircleLine,
  RiImageLine,
  RiGalleryLine,

  // Comunicação
  RiMailLine,
  RiMessage3Line,
  RiChat3Line,
  RiQuestionnaireLine,
  RiPhoneLine,
  RiCustomerService2Line,
  RiNotification3Line,
  RiFeedbackLine,
  RiSendPlaneLine,
  RiReplyLine,

  // Documentos e Arquivos
  RiFileTextLine,
  RiFolderLine,
  RiFile3Line,
  RiFilePdfLine,
  RiFileExcelLine,
  RiFileWordLine,
  RiFilePpt2Line,
  RiFileZipLine,
  RiFileCodeLine,
  RiArticleLine,
  RiBookOpenLine,
  RiBook2Line,
  RiNewspaperLine,

  // Educação e Aprendizado
  RiGraduationCapLine,
  RiSchoolLine,
  RiBookmarkLine,
  RiLightbulbFlashLine,
  RiLightbulbLine,
  RiQuillPenLine,
  RiPresentationLine,
  RiPieChart2Line,
  RiBarChartBoxLine,
  RiLineChartLine,

  // Transporte e Lugares
  RiCarLine,
  RiTruckLine,
  RiBusLine,
  RiTaxiLine,
  RiRocketLine,
  RiPlaneLine,
  RiShipLine,
  RiBikeLine,
  RiPinDistanceLine,
  RiMapPinLine,
  RiNavigationLine,
  RiCompassLine,
  RiGlobalLine,
  RiEarthLine,

  // Tempo e Calendário
  RiTimeLine,
  RiTimer2Line,
  RiAlarmLine,
  RiCalendarCheckLine,
  RiCalendar2Line,
  RiCalendarEventLine,
  RiHourglass2Line,

  // Segurança e Proteção
  RiShieldCheckLine,
  RiShieldLine,
  RiLockPasswordLine,
  RiLockLine,
  RiKeyLine,
  RiEyeLine,
  RiFingerprint2Line,
  RiPoliceCarLine,

  // Saúde e Medicina
  RiHeartPulseLine,
  RiMentalHealthLine,
  RiPsychotherapyLine,
  RiStethoscopeLine,
  RiMedicineBottleLine,
  RiFirstAidKitLine,
  RiSyringeLine,
  RiTestTubeLine,

  // Alimentos e Bebidas
  RiCakeLine,
  RiDrinks2Line,
  RiGobletLine,
  RiRestaurant2Line,

  // Natureza e Clima
  RiLeafLine,
  RiPlantLine,
  RiFlowerLine,
  RiSunLine,
  RiMoonLine,
  RiCloudyLine,
  RiRainyLine,
  RiThunderstormsLine,
  RiFireLine,
  RiFlashlightLine,
  RiSparklingLine,

  // Casa e Vida
  RiHome4Line,
  RiHome2Line,
  RiDoorOpenLine,
  RiSofaLine,

  // Esportes e Atividades
  RiFootballLine,
  RiBasketballLine,
  RiBilliardsLine,
  RiBox3Line,
  RiRunLine,

  // Ação e Interface
  RiCheckboxCircleLine,
  RiCheckDoubleLine,
  RiAddCircleLine,
  RiDeleteBinLine,
  RiRefreshLine,
  RiDownloadLine,
  RiUploadLine,
  RiShareLine,
  RiLinksLine,
  RiExternalLinkLine,
  RiArrowRightCircleLine,
  RiArrowLeftCircleLine,

  // Aplicativos e Serviços
  RiApps2Line,
  RiServiceLine,
  RiCustomerServiceLine,
  RiAppleLine,
  RiAndroidLine,
  RiWindowsLine,
  RiChromeLine,

  // Outros Úteis
  RiGiftLine,
  RiFlag2Line,
  RiPushpin2Line,
  RiBatteryChargeLine,
  RiSignalWifiLine,
  RiBankLine,
  RiBuildingLine,
  RiGovernmentLine,
  RiHospitalLine,
  RiHotelLine,
  RiAnchorLine,
  RiSuitcaseLine,
  RiUmbrellaLine,
} from "react-icons/ri";
import { ModalTitle, IconGrid, IconButton } from "./styles";

const AVAILABLE_ICONS = [
  // Default
  { name: "Default", component: RiApps2Line },

  // Negócios e Comércio
  { name: "Shopping Bag", component: RiShoppingBag3Line },
  { name: "Shopping Cart", component: RiShoppingCart2Line },
  { name: "Store", component: RiStore2Line },
  { name: "Shopping Basket", component: RiShoppingBasketLine },
  { name: "Briefcase", component: RiBriefcase4Line },
  { name: "Hand Coin", component: RiHandCoinLine },
  { name: "Dollar", component: RiMoneyDollarCircleLine },
  { name: "Coupon", component: RiCoupon3Line },
  { name: "Price Tag", component: RiPriceTag3Line },
  { name: "Barcode", component: RiBarcodeLine },
  { name: "Wallet", component: RiWallet3Line },
  { name: "Refund", component: RiRefund2Line },
  { name: "Exchange", component: RiExchangeLine },
  { name: "Auction", component: RiAuctionLine },
  { name: "Secure Payment", component: RiSecurePaymentLine },

  // Destaque e Reconhecimento
  { name: "Star", component: RiStarLine },
  { name: "Trophy", component: RiTrophyLine },
  { name: "Medal", component: RiMedalLine },
  { name: "Award", component: RiAwardLine },
  { name: "Cup", component: RiCupLine },
  { name: "Crown", component: RiVipCrownLine },
  { name: "Diamond", component: RiVipDiamondLine },
  { name: "Shield Star", component: RiShieldStarLine },

  // Emoções e Social
  { name: "Heart", component: RiHeartLine },
  { name: "Happy", component: RiEmotionHappyLine },
  { name: "Laugh", component: RiEmotionLaughLine },
  { name: "Thumb Up", component: RiThumbUpLine },
  { name: "Thumb Down", component: RiThumbDownLine },
  { name: "Hand Heart", component: RiHandHeartLine },
  { name: "User Heart", component: RiUserHeartLine },
  { name: "Team", component: RiTeamLine },
  { name: "User Star", component: RiUserStarLine },
  { name: "User Smile", component: RiUserSmileLine },

  // Tecnologia e Dispositivos
  { name: "Computer", component: RiComputerLine },
  { name: "Smartphone", component: RiSmartphoneLine },
  { name: "Tablet", component: RiTabletLine },
  { name: "Macbook", component: RiMacbookLine },
  { name: "Server", component: RiServerLine },
  { name: "Hard Drive", component: RiHardDriveLine },
  { name: "Database", component: RiDatabase2Line },
  { name: "Cloud", component: RiCloudLine },
  { name: "Wifi", component: RiWifiLine },
  { name: "USB", component: RiUsbLine },
  { name: "CPU", component: RiCpuLine },

  // Ferramentas e Configurações
  { name: "Tools", component: RiToolsLine },
  { name: "Settings 3", component: RiSettings3Line },
  { name: "Settings 4", component: RiSettings4Line },
  { name: "Hammer", component: RiHammerLine },
  { name: "Scissors", component: RiScissorsLine },
  { name: "Paint Brush", component: RiPaintBrushLine },
  { name: "Palette", component: RiPaletteLine },
  { name: "Magic", component: RiMagicLine },
  { name: "Drag Drop", component: RiDragDropLine },
  { name: "Edit", component: RiEdit2Line },
  { name: "Pencil", component: RiPencilLine },

  // Mídia e Entretenimento
  { name: "Camera", component: RiCameraLine },
  { name: "Video", component: RiVideoLine },
  { name: "Film", component: RiFilmLine },
  { name: "Music", component: RiMusic2Line },
  { name: "Headphone", component: RiHeadphoneLine },
  { name: "Mic", component: RiMicLine },
  { name: "Volume Up", component: RiVolumeUpLine },
  { name: "Play", component: RiPlayCircleLine },
  { name: "Pause", component: RiPauseCircleLine },
  { name: "Image", component: RiImageLine },
  { name: "Gallery", component: RiGalleryLine },

  // Comunicação
  { name: "Mail", component: RiMailLine },
  { name: "Message", component: RiMessage3Line },
  { name: "Chat", component: RiChat3Line },
  { name: "Questionnaire", component: RiQuestionnaireLine },
  { name: "Phone", component: RiPhoneLine },
  { name: "Customer Service", component: RiCustomerService2Line },
  { name: "Notification", component: RiNotification3Line },
  { name: "Feedback", component: RiFeedbackLine },
  { name: "Send", component: RiSendPlaneLine },
  { name: "Reply", component: RiReplyLine },

  // Documentos e Arquivos
  { name: "File Text", component: RiFileTextLine },
  { name: "Folder", component: RiFolderLine },
  { name: "File", component: RiFile3Line },
  { name: "PDF", component: RiFilePdfLine },
  { name: "Excel", component: RiFileExcelLine },
  { name: "Word", component: RiFileWordLine },
  { name: "PowerPoint", component: RiFilePpt2Line },
  { name: "Zip", component: RiFileZipLine },
  { name: "Code", component: RiFileCodeLine },
  { name: "Article", component: RiArticleLine },
  { name: "Book Open", component: RiBookOpenLine },
  { name: "Book", component: RiBook2Line },
  { name: "Newspaper", component: RiNewspaperLine },

  // Educação e Aprendizado
  { name: "Graduation Cap", component: RiGraduationCapLine },
  { name: "School", component: RiSchoolLine },
  { name: "Bookmark", component: RiBookmarkLine },
  { name: "Lightbulb Flash", component: RiLightbulbFlashLine },
  { name: "Lightbulb", component: RiLightbulbLine },
  { name: "Quill Pen", component: RiQuillPenLine },
  { name: "Presentation", component: RiPresentationLine },
  { name: "Pie Chart", component: RiPieChart2Line },
  { name: "Bar Chart", component: RiBarChartBoxLine },
  { name: "Line Chart", component: RiLineChartLine },

  // Transporte e Lugares
  { name: "Car", component: RiCarLine },
  { name: "Truck", component: RiTruckLine },
  { name: "Bus", component: RiBusLine },
  { name: "Taxi", component: RiTaxiLine },
  { name: "Rocket", component: RiRocketLine },
  { name: "Plane", component: RiPlaneLine },
  { name: "Ship", component: RiShipLine },
  { name: "Bike", component: RiBikeLine },
  { name: "Distance", component: RiPinDistanceLine },
  { name: "Map Pin", component: RiMapPinLine },
  { name: "Navigation", component: RiNavigationLine },
  { name: "Compass", component: RiCompassLine },
  { name: "Global", component: RiGlobalLine },
  { name: "Earth", component: RiEarthLine },

  // Tempo e Calendário
  { name: "Time", component: RiTimeLine },
  { name: "Timer", component: RiTimer2Line },
  { name: "Alarm", component: RiAlarmLine },
  { name: "Calendar Check", component: RiCalendarCheckLine },
  { name: "Calendar", component: RiCalendar2Line },
  { name: "Calendar Event", component: RiCalendarEventLine },
  { name: "Hourglass", component: RiHourglass2Line },

  // Segurança e Proteção
  { name: "Shield Check", component: RiShieldCheckLine },
  { name: "Shield", component: RiShieldLine },
  { name: "Lock Password", component: RiLockPasswordLine },
  { name: "Lock", component: RiLockLine },
  { name: "Key", component: RiKeyLine },
  { name: "Eye", component: RiEyeLine },
  { name: "Fingerprint", component: RiFingerprint2Line },
  { name: "Police Car", component: RiPoliceCarLine },

  // Saúde e Medicina
  { name: "Heart Pulse", component: RiHeartPulseLine },
  { name: "Mental Health", component: RiMentalHealthLine },
  { name: "Psychotherapy", component: RiPsychotherapyLine },
  { name: "Stethoscope", component: RiStethoscopeLine },
  { name: "Medicine Bottle", component: RiMedicineBottleLine },
  { name: "First Aid Kit", component: RiFirstAidKitLine },
  { name: "Syringe", component: RiSyringeLine },
  { name: "Test Tube", component: RiTestTubeLine },

  // Alimentos e Bebidas
  { name: "Cake", component: RiCakeLine },
  { name: "Drinks", component: RiDrinks2Line },
  { name: "Goblet", component: RiGobletLine },
  { name: "Restaurant", component: RiRestaurant2Line },

  // Natureza e Clima
  { name: "Leaf", component: RiLeafLine },
  { name: "Plant", component: RiPlantLine },
  { name: "Flower", component: RiFlowerLine },
  { name: "Sun", component: RiSunLine },
  { name: "Moon", component: RiMoonLine },
  { name: "Cloudy", component: RiCloudyLine },
  { name: "Rainy", component: RiRainyLine },
  { name: "Thunderstorms", component: RiThunderstormsLine },
  { name: "Fire", component: RiFireLine },
  { name: "Flashlight", component: RiFlashlightLine },
  { name: "Sparkling", component: RiSparklingLine },

  // Casa e Vida
  { name: "Home 4", component: RiHome4Line },
  { name: "Home", component: RiHome2Line },
  { name: "Door Open", component: RiDoorOpenLine },
  { name: "Sofa", component: RiSofaLine },

  // Esportes e Atividades
  { name: "Football", component: RiFootballLine },
  { name: "Basketball", component: RiBasketballLine },
  { name: "Billiards", component: RiBilliardsLine },
  { name: "Boxing", component: RiBox3Line },
  { name: "Run", component: RiRunLine },

  // Ação e Interface
  { name: "Check Circle", component: RiCheckboxCircleLine },
  { name: "Check Double", component: RiCheckDoubleLine },
  { name: "Add Circle", component: RiAddCircleLine },
  { name: "Delete Bin", component: RiDeleteBinLine },
  { name: "Refresh", component: RiRefreshLine },
  { name: "Download", component: RiDownloadLine },
  { name: "Upload", component: RiUploadLine },
  { name: "Share", component: RiShareLine },
  { name: "Links", component: RiLinksLine },
  { name: "External Link", component: RiExternalLinkLine },
  { name: "Arrow Right", component: RiArrowRightCircleLine },
  { name: "Arrow Left", component: RiArrowLeftCircleLine },

  // Aplicativos e Serviços
  { name: "Apps", component: RiApps2Line },
  { name: "Service", component: RiServiceLine },
  { name: "Customer Service 2", component: RiCustomerServiceLine },
  { name: "Apple", component: RiAppleLine },
  { name: "Android", component: RiAndroidLine },
  { name: "Windows", component: RiWindowsLine },
  { name: "Chrome", component: RiChromeLine },

  // Outros Úteis
  { name: "Gift", component: RiGiftLine },
  { name: "Flag", component: RiFlag2Line },
  { name: "Pushpin", component: RiPushpin2Line },
  { name: "Battery Charge", component: RiBatteryChargeLine },
  { name: "Signal Wifi", component: RiSignalWifiLine },
  { name: "Bank", component: RiBankLine },
  { name: "Building", component: RiBuildingLine },
  { name: "Government", component: RiGovernmentLine },
  { name: "Hospital", component: RiHospitalLine },
  { name: "Hotel", component: RiHotelLine },
  { name: "Anchor", component: RiAnchorLine },
  { name: "Suitcase", component: RiSuitcaseLine },
  { name: "Umbrella", component: RiUmbrellaLine },
];

const IconPickerModal = ({ visible, onCancel, onSelect }) => {
  const handleIconSelect = useCallback(
    (icon) => {
      onSelect(icon);
    },
    [onSelect]
  );

  return (
    <Modal
      modalIsOpen={visible}
      setIsOpen={onCancel}
      modalWidth="750px"
      dontCloseByClick={false}
      borderRadius="8px"
    >
      <ModalTitle>
        <FormattedMessage id="select_icon" />
      </ModalTitle>

      <IconGrid>
        {AVAILABLE_ICONS.map(({ name, component: IconComponent }) => (
          <IconButton
            key={name}
            type="button"
            onClick={() => handleIconSelect({ name, component: IconComponent })}
          >
            <IconComponent />
          </IconButton>
        ))}
      </IconGrid>
    </Modal>
  );
};

IconPickerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export { AVAILABLE_ICONS };
export default IconPickerModal;
